import {
  dedupeSignersByUserId,
  tagRepresentativesWithSource,
  type TitleSignerSource,
} from "@/features/signers-infinite-scroll";

const SECTION_FOUR_SIGNER_ROLE: Record<TitleSignerSource, string> = {
  developer: "Уполномоченный представитель застройщика по стройконтролю",
  technicalCustomer:
    "Уполномоченный представитель технического заказчика по стройконтролю",
};

type SignerLike = {
  signerSource?: TitleSignerSource;
  user?: {
    userId?: string;
    surname?: string;
    firstName?: string;
    middleName?: string;
  };
};

export const buildSectionFourSignersList = (
  developerControls: SignerLike[] = [],
  technicalCustomerControls: SignerLike[] = [],
) =>
  dedupeSignersByUserId(
    tagRepresentativesWithSource(developerControls, technicalCustomerControls),
  );

export const SECTION_FOUR_CONTROL_REPRESENTATIVE_ROLE =
  "Уполномоченный представитель по вопросам строительного контроля";

export const formatSectionFourSignerLabel = (signer?: SignerLike | null) => {
  if (!signer) {
    return "";
  }

  const fio = [
    signer.user?.surname,
    signer.user?.firstName,
    signer.user?.middleName,
  ]
    .filter(Boolean)
    .join(" ");

  const role = signer.signerSource
    ? SECTION_FOUR_SIGNER_ROLE[signer.signerSource]
    : "";

  return [role, fio].filter(Boolean).join(" ");
};
